import { RootState } from '@/models/root-state.model';
import { BffCmsHeroBackgroundResponse } from '@lucky7ventures/bff-types';

export const selectHeroBackgrounds = (state: RootState): BffCmsHeroBackgroundResponse =>
  state.heroBackgrounds?.heroBackgrounds;
export const selectHeroBackgroundsLoading = (state: RootState): boolean =>
  state.heroBackgrounds.loading;
